import { ProductModel } from "./product.model";

export class ProductStoreModel {
    public product: ProductModel;
    public quantity: number;
    public data: string;
}